import { render, staticRenderFns } from "./ChatflowPage.vue?vue&type=template&id=015c83ee&scoped=true"
var script = {}
import style0 from "./ChatflowPage.vue?vue&type=style&index=0&id=015c83ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015c83ee",
  null
  
)

export default component.exports